export default __webpack_public_path__ + "static/media/discount75.7affda08.jpg";